<template>
  <div v-editable="blok" :class="styles" v-html="blok.copy.html"></div>
</template>
<script>
export default {
  name: "text-blok",
  props: ["blok"],
  computed: {
    styles: function() {
      const b = this.$props.blok;
      return ["text-blok", b.width, b.align, b.styles];
    }
  }
};
</script>